import { SchmancyElement } from '@schmancy/mixins/index'
import { css, html } from 'lit'
import { customElement } from 'lit/decorators.js'

@customElement('schmancy-card-action')
export default class SchmancyCardAction extends SchmancyElement {
	static styles = [
		css`
			/* !important is load-bearing, the same cascade fact schmancy-card-content
			   pins: a consumer's baked Tailwind preflight resets every element's
			   padding to 0, and for normal declarations the outer tree wins over
			   :host at any specificity. Importance is what flips context the other
			   way — without it every consumer's global reset silently strips this
			   component's default padding. */
			:host {
				display: flex;
				gap: 0.5rem;
				padding: 0.5rem 1rem !important;
				align-items: center;
				justify-content: flex-end;
			}
		`,
	]
	protected render(): unknown {
		return html`<slot></slot>`
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'schmancy-card-action': SchmancyCardAction
	}
}
